import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { TextField } from '@mui/material';

import * as S from './CellEditor.styles';
import { ICellEditorImperativeHandle } from 'interfaces/dataGrid';

type TRef = {};

type TProps = {
  [field: string]: any;
};

const CellEditor = React.forwardRef<TRef, TProps>((props, ref) => {
  const {
    context: { formik },
    eGridCell: { offsetHeight },
  } = props;

  const [value, setValue] = useState('');
  const [field, setField] = useState(props.colDef.field);
  const [error, setError] = useState<string | null>();
  const [editable, setEditable] = useState<boolean>(false);

  const refInput = useRef<React.RefObject<HTMLInputElement>>(null);

  useEffect(() => {
    if (typeof props.value === 'string' || typeof props.value === 'number') {
      setValue(props?.value.toString());
    } else if (typeof props.value === 'object') {
      setValue(props?.value?.value);
    } else {
      // setValue(props.value.value);
    }
  }, [props.value]);

  useEffect(() => {
    if (refInput.current !== null) {
      refInput.current.current?.focus();
    }
    setField(props.colDef.field);
  }, [props.colDef.field]);

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, (): ICellEditorImperativeHandle => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        // this simple editor doubles any value entered into the input
        return value;
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if Enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        // our editor will reject any cell that has an error
        return !!error;
      },

      columnField: () => field,
      validateField: (error) => setError(error),
      setEditable: (editable) => setEditable(editable),
      setValue: (value) => setValue(value),
    };
  });

  return (
    <S.CellEditor cellHeight={offsetHeight}>
      <TextField
        error={!!error}
        disabled={editable}
        inputRef={refInput}
        helperText={error}
        id={`TextField-${props.colDef.field}`}
        value={value}
        onChange={(e) => {
          const fieldName = props.colDef.field;
          const fieldValues = formik.values[props.colDef.field];
          if (fieldName) {
            formik.setFieldValue(fieldName, {
              ...fieldValues,
              value: e.target.value,
            });
          }
          setValue(e.target.value);
        }}
      />
    </S.CellEditor>
  );
});

export default CellEditor;
